import { useEffect, useState } from "react";

import { WizardNew } from "shared/components/WizardNew";
import { WizardResponce } from "shared/components/WizardNew/types";

import { TOKEN_KEY } from "shared/constants/auth";

import { deleteCookie } from "shared/helpers/cookie";
import { escapeProfile } from "shared/helpers/wizard";

import { getWizard } from "shared/services/wizard";

const WizardFactory = () => {
  const [wizardData, setWizardData] = useState(null);

  useEffect(() => {
    getWizard()
      .then(({ data }: { data: WizardResponce }) => {
        const responce = escapeProfile(data.data);

        if (!data.success) {
          deleteCookie(TOKEN_KEY);
          window.location.href = import.meta.env.logoutUrl;
          return false;
        }
        setWizardData({ ...responce, isFetched: true });
      })
      .catch((error: { message: string }) => {
        console.log(error.message);
      });
  }, []);

  if (!wizardData) return null;

  return <WizardNew wizardData={wizardData} />;
};

export { WizardFactory };
